export default {
  name: 'cic_petroleo',
  description: 'Dinamica de negociación Cambridge International Consulting',
  drawer: null,
  color: '#FC8F00',
  image: '/static/img/runners.jpg'
}
